module.exports = __webpack_public_path__ + "assets/img/Pink_Dating.7632be3d.svg";